const login = [
  {
    // 登录
    path: "/login",
    name: "login",
    component: () => import("../views/login/login.vue")
  },
  {
    // 单点登录
    path: "/ssologin",
    name: "ssologin",
    component: () => import("../views/login/ssoLogin.vue")
  },
  {
    // 忘记密码
    path: "/forgetpwd",
    name: "forgetpwd",
    component: () => import("../views/login/forgetpwd.vue")
  },
  {
    // 注册
    path: "/regist",
    name: "regist",
    component: () => import("../views/login/register.vue")
  },
  {
    // 个人信息修改
    path: "/accountInfoOpe",
    name: "accountInfoOpe",
    component: () => import("../views/login/accountInfoOpe.vue")
  },
  {
    // 验证手机号页面
    path: "/checkphone",
    name: "checkphone",
    component: () => import("../views/login/checkphone.vue")
  },
  {
    // 宣传页
    path: "/leafLet",
    name: "leafLet",
    component: () => import("../views/leafLet.vue")
  },
  {
    // 支付宝支付页面
    path: "/payGateWay",
    name: "payGateWay",
    component: () => import("../views/payGateWay.vue")
  },
  {
    // 用户协议
    path: "/agreement",
    name: "agreement",
    component: () => import("../views/agreement.vue")
  },
  {
    // 用户协议
    path: "/agreementUSD",
    name: "agreementUSD",
    component: () => import("../views/agreementUSD.vue")
  },
  {
    // 隐私政策
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () => import("../views/privacyPolicy.vue")
  },
  {
    // 免责声明
    path: "/disclaimers",
    name: "disclaimers",
    component: () => import("../views/disclaimers.vue")
  },
  {
    // 隐私政策
    path: "/privacyPolicyUSD",
    name: "privacyPolicyUSD",
    component: () => import("../views/privacyPolicyUSD.vue")
  },
  {
    //切换域名公告
    path: "/announcement",
    name: "announcement",
    component: () => import("../views/announcement.vue")
  },
  {
    //elementUI issue
    path: "/elementIssue",
    name: "elementIssue",
    component: () => import("../views/elementIssue.vue")
  },
  {
    //h5 首页
    path: "/indexPageh5",
    name: "indexPageh5",
    component: () => import("../views/indexPageH5.vue")
  }
];

export default login;
